import { Typography } from '@mui/material';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './HorizontalLabelGroup.module.scss';


interface HorizontalLabelGroupProps {
    children?: ReactNode;
    title?: string;
    className?: string;
}

export function HorizontalLabelGroup({ children, title, className }: HorizontalLabelGroupProps) {
    return (
        <div className={clsx(styles.root, className)}>
            {title && (
                <Typography className={styles.header}>
                    {title}
                </Typography>
            )}

            {children}
        </div>
    );
}
